module.exports = __webpack_public_path__ + "img/mode-open-case.6a70a5c4.svg";